// Left panel — shown when the desktop app is signed in as a DIFFERENT account
// than the dashboard session.
//
// Nothing to install and nothing to sign into: the app is running and logged
// in, just as somebody else. Connect stays disabled because every tunnel call
// would act on the desktop account, not on the person using this dashboard.
//
// The two accounts stack vertically rather than sitting in the deviceMeta grid
// — emails are long enough to collide in a fixed three-column row.
//
// `handoff` is owned by the page (see Connect/index.js) and shared with the
// rail, so whichever button you press locks both.
import styles from "../Connect.module.css";
import { useDaemon } from "../../../context/DaemonContext";
import { useAuth } from "../../../context/AuthContext";

export default function WrongUserPanel({ handoff }) {
  const { daemonUser } = useDaemon();
  const { user } = useAuth();
  const { signIn, pending, error } = handoff;

  const appEmail = daemonUser?.email ?? "Unknown account";
  const myEmail  = user?.email ?? "your account";

  return (
    <section className={styles.panel}>
      <h2 className={styles.panelTitle}>Different account signed in</h2>
      <p className={styles.panelSubtitle}>
        The PQ VPN app on this machine is signed in as another user, so it can't
        start a tunnel for your session.
      </p>

      <div className={styles.deviceList}>
        <div className={styles.mismatchCard}>
          <div className={styles.mismatchRow}>
            <span className={styles.mismatchLabel}>
              <span className={styles.mismatchDot} />
              DESKTOP APP
            </span>
            <span className={styles.mismatchEmail}>{appEmail}</span>
          </div>

          <div className={styles.mismatchRow}>
            <span className={styles.mismatchLabel}>
              <span className={`${styles.mismatchDot} ${styles.mismatchDotOwn}`} />
              THIS DASHBOARD
            </span>
            <span className={styles.mismatchEmail}>{myEmail}</span>
          </div>

          <button
            type="button"
            className={`${styles.btn} ${styles.btnWarn} ${styles.mismatchAction}`}
            onClick={signIn}
            disabled={pending}
          >
            {/* The address is spelled out in the row directly above, so the
                button says what it does rather than repeating it. */}
            {pending ? "SWITCHING…" : "SWITCH THE APP TO MY ACCOUNT"}
          </button>
        </div>
      </div>

      {error && <p className={styles.handoffError}>{error}</p>}

      <p className={styles.deviceListNote}>
        Switching signs the app out of {appEmail} and back in as {myEmail} using
        your current dashboard session. This page updates on its own once the two
        match.
      </p>
    </section>
  );
}
